<div style="padding: 15px 0px;">
    <div [innerHTML]="question.content.text | replacePatientTerm : question.content.patientTerms : patientTerm! | sanitizeHtml"></div>

    <mat-form-field class="full-width" [ngClass]="{'is-preview-mode' : isPreview}" >
        <label id="example-textarea-label" for="textAreaBox" >
            <textarea id="textAreaBox" matInput maxlength="{{this.maxCharacterCount}}" [(ngModel)]="question.responseText" (focusout)="saveAnswer()" 
            cdkTextareaAutosize #myTextArea="cdkTextareaAutosize" cdkAutosizeMinRows="8" placeholder="{{this.textAreaPlaceHolderLine}}" cdkAutosizeMaxRows="25">{{question.responseText}}</textarea>
            <mat-hint class="character-count" i18n="Comments Character Count|Maximum number of caracters allowed to be entered in to the comments box@@commentCharacterMaximumCount">{{question.responseText.length}}/{{this.maxCharacterCount}} characters</mat-hint>
        </label>
    </mat-form-field>
    <mat-divider></mat-divider>
</div>